<template>
    <div class="rich_media_content " id="js_content">
        <h2 class="rich_media_title zhemo" id="activity-name" style="padding-bottom:30px">
            【量化学堂】多因子模型简介
        </h2>




        <p>多因子模型是量化选股策略中最常见的一类模型，其基本思想就是找到某些与收益率最相关的指标，并根据该指标，构建一个股票组合，期望该组合在未来的一段时间内能跑赢市场。通过做多股票组合，做空股指期货的方式构建一个具有市场中性的投资组合以获取稳定的阿尔法收益。<br>
        </p>
        <br>
        <p>多因子模型理论源于1955年马科维兹提出的资本资产定价模型，该模型将<span>证券投资者所获得的收益分为两部分：</span><span>来自市场的收益以及独立于市场的超额收益</span><span>。来自市场的平均收益是无法控制的，由整个宏观经济所决定，能够掌控的是独立于市场的超额收益。1992年，Fama和French提出的三因子模型是多因子模型的前身。<span>Fama和French对决定</span></span><span>美国股票市场</span><span>不同股票回报率差异的因素进行大量对比后，提出了著名的</span><span>三因子模型</span><span>。他们认为股票跟随的市场收益值不能解释不同股票回报率的差异，而上市公司的市值、账面市值比、市盈率则可以解释股票回报率的差异。<span>多因子模型事实上就是将</span><span>三因素拓展为多因素，由此诞生了现在最为成熟的多因子模型。</span></span>
        </p>
        <br>
        <p>现代多因子量化投资体系包含三个不可或缺的重要部分：alpha因子、风险模型与组合优化。在这三个环节之中，风险模型与组合优化已有不少优秀的商业解决方案，并在投资界中也形成了一定的标准（如：Barra的风险模型、Axioma的优化器等），其背后相对完善、精确的数量金融理论背景使得这两个部分的应用日趋成熟。作为多因子模型的核心，投资组合超额收益的来源——alpha模型的构建却是一个仁者见仁智者见智的问题。选择哪些alpha因子，各个alpha因子的权重应如何配置，这些问题到目前都没有一个统一完善的解决方案。不仅如此，随着市场中主动量化投资主体的增加，特别是多因子模型的广泛运用，传统alpha因子的超额收益在不断下降，而波动性则有明显上升的趋势。虽然中国的股票市场远未达到欧美股市的有效程度，但却呈现出高度竞争的状态。市场及存在于期间的投资者从数据和自身的经验中不断的学习，因此昨天的市场“异象”（或无效点），很快成为了今天的随机噪声！要想保持投资组合超额收益的稳定性，就必须不断发现新的、市场还未充分反映的alpha因子。
        </p>
        <br>
        <p><span></span></p>
        <p></p>
        <section class="title2" label="Copyright © 2015 Yead All Rights Reserved.">
            <p>
                多因子模型的α来源
            </p>
        </section>
        <br>
        <p></p>
        <p>多因子模型可能的Alpha 来源主要包含三个方面，即因子、风格和组合。</p>
        <p class="title2"><strong>1、寻找有效因子</strong></p>
        <p>由于因子的有效性是不断<span>变化的，不论是经济环境的变化还是投资者的竞争加剧，原先有效的因子，现在</span><span>可能已经衰竭，因此必须不断寻找有效因子。获取有效因子的途径包括寻找新的</span><span>因子和改造旧的因子。</span>
        </p>
        <p>（1） 寻找新因子：寻找新的投资逻辑是获得有效因子的重要方式；</p>
        <p>（2） 改造现有因子：对现有因子根据不同的数据或逻辑加以改造、重构、</p>
        <p>提高因子的有效性，也是获得有效因子的另一个重要方式。</p>
        <br>
        <p class="title2"><strong>2、分析因子风格</strong></p>
        <p>建立完因子池后，构建多因子模型的一个直接问题就是研究如何对因子赋</p>
        <p>予不同的权重，也即分析因子风格，进行风格的轮动或者选时。风格研究主要包括：</p>
        <p>（1） 风格划分与轮动：主要研究如何将因子划分为不同的风格，如何在各</p>
        <p>种情况下进行风格的选择；</p>
        <p>（2） 因子评价与筛选：建立获得高效因子的标准策略。</p>
        <br>
        <p class="title2"><strong>3、股票组合的赋权</strong></p>
        <p>如何优化组合权重，并通过仿真实施<span>筛选出最优的股票组合是该部分要解决的主要问题。</span></p>
        
        <p></p>
        <br>
        <p class="title2" label="Copyright © 2015 Yead All Rights Reserved.">
            因子库的构成
        </p>
        <p></p>
        <p>在因子库中，一般可以将单因子划分为7个部分：</p>
        <p>（1）价值类因子：估值因子，常见的PE、PB等等；</p>
        <p>（2）成长类因子：业绩成长因子，常见的净利润增长率、营业收入增长率等等；</p>
        <p>（3）规模类因子：与规模相关的因子，常见的总资产、总市值等等；</p>
        <p>（4）动量类因子：价格和交易量因子，常见的一个月动量、三个月动量等等</p>
        <p>（5）情绪类因子：盈利预测因子，常见的预测评级变动、预测分散度等；</p>
        <p>（6）质量类因子：与财务质量、资本结构相关的因子，如ROE、资产负债率等；</p>
        <p>（7）技术类因子：与技术指标和风险相关的因子，常见的MACD、RSI</p>
        <br>
        <br>
        <p style="text-align:center;"><img class=""
        width="520px"
                src="./img/img_2_8_1.png"
                alt="图片"><br></p>
        <br>
        
        <p>
        
            <br>
            <br>
            <img style="display:block;margin:0 auto;"
            width="520px"
            src="./img/img_2_8_2.png"
            alt="图片">
        </p>
        <p><br></p>
        <p class="free">（来源：汇鸿汇升投资）</p>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
    .zhemo {
        text-align: center;
        padding: 40px 0 20px 0;
        font-weight: bold;
        color: #6f6f6f !important;
    }

    .title2 {
        font-weight: bold;
        line-height: 30px;
    }

    p,
    span {
        text-indent: 2em;
        font-size: 14px !important;
        color: #6f6f6f !important;
        letter-spacing: 0 !important;
    }
</style>